import { NgFor } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { TranslatorService } from '@sc/data-access-translation';
import { ButtonComponent } from '../button';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-no-show-comment',
  styleUrls: ['./no-show-comment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgFor,
    ReactiveFormsModule,
    IconComponent,
    ButtonComponent,
    MatRadioModule,
    MatInputModule,
    TranslateModule,
  ],
  template: `
    <div class="container" [formGroup]="form">
      <div class="close">
        <button buttonType="tertiary" class="close-btn" (click)="cancelClick()">
          <sc-icon name="close"></sc-icon>
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate: { dialogTitle: 'NoShowComment.title' | translate }
          }}</span>
        </button>
      </div>
      <h1
        mat-dialog-title
        id="no-show-comment-title-id"
        class="sc-design-title-h3"
      >
        {{ 'NoShowComment.title' | translate }}
      </h1>
      <mat-radio-group formControlName="reasonChoice">
        <mat-radio-button
          *ngFor="let option of reasonChoices"
          [value]="option?.code"
          [checked]="form?.get('reasonChoice')?.value?.code === option?.code"
          >{{ option?.ihm }}</mat-radio-button
        >
      </mat-radio-group>
      <textarea
        matInput
        #cancelCommentText
        [placeholder]="'NoShowComment.textareaPlaceHolder' | translate"
        formControlName="specificReason"
      ></textarea>
      <sc-button
        [disabled]="!canValidate()"
        buttonType="primary"
        (click)="validateClick()"
        >{{ 'NoShowComment.validateBtn' | translate }}</sc-button
      >
      <sc-button
        id="cancelBtn"
        buttonType="secondary"
        (click)="cancelClick()"
        >{{ 'NoShowComment.cancelBtn' | translate }}</sc-button
      >
    </div>
  `,
})
export class NoShowCommentComponent implements OnInit {
  form: FormGroup;

  @Output() actionClick = new EventEmitter<string>();

  reasonChoices: { code: string; ihm: string }[];

  constructor(private readonly translatorService: TranslatorService) {}

  ngOnInit() {
    this.reasonChoices = [
      {
        code: 'GONETOCOMPETITION',
        ihm: this.translatorService.getInstantTranslation(
          'NoShowComment.reasonChoices.goneToCompetition'
        ),
      },
      {
        code: 'REPROGRAMMED',
        ihm: this.translatorService.getInstantTranslation(
          'NoShowComment.reasonChoices.reprogrammed'
        ),
      },
      {
        code: 'UNKNOWN',
        ihm: this.translatorService.getInstantTranslation(
          'NoShowComment.reasonChoices.unknown'
        ),
      },
      {
        code: 'OTHER',
        ihm: this.translatorService.getInstantTranslation(
          'NoShowComment.reasonChoices.other'
        ),
      },
    ];

    this.form = new FormGroup({
      reasonChoice: new FormControl(null, Validators.required),
      specificReason: new FormControl({ value: null, disabled: true }),
    });
    this.form.get('reasonChoice').valueChanges.subscribe((value) => {
      if (value === 'OTHER') {
        this.form?.get('specificReason')?.enable();
      } else {
        this.form?.get('specificReason')?.disable();
      }

      this.form.updateValueAndValidity();
    });
  }

  canValidate() {
    return (
      this.form.valid &&
      (this.form.get('reasonChoice')?.value !== 'OTHER' ||
        this.form.get('specificReason')?.value?.length >= 5)
    );
  }

  cancelClick() {
    this.actionClick.emit('CANCEL');
  }

  validateClick() {
    if (!this.canValidate()) return;

    this.actionClick.emit(
      this.form?.get('reasonChoice')?.value === 'OTHER'
        ? this.form?.get('specificReason')?.value
        : this.reasonChoices.find(
            (choice) => choice.code === this.form?.get('reasonChoice')?.value
          )?.ihm
    );
  }
}
